const Styles = {
  colorPrimary: "#fd5857",
};

export default Styles;
